import { Col } from 'antd';
import { useTranslation } from 'react-i18next';
import CompanyCurrencyField from '../../../../components/fields/CompanyCurrencyField';
import FormFields from '../../../../themes/admin/Fields/FormFields';
import useSystemSwitchData from '../../../../utilities/useSystemSwitchData';
import { useVariantConfigurator } from '../VariantConfiguratorContext';

type NameProps = {
    name: string;
    disabled?: boolean;
};

const PackagePriceTypeFieldGroup = ({ name, disabled = false }: NameProps) => {
    const { t } = useTranslation(['variantConfiguratorDetails']);

    const { yesNoSwitch } = useSystemSwitchData();

    const { variantConfigurator } = useVariantConfigurator();

    return (
        <>
            <Col lg={8} xs={24}>
                <CompanyCurrencyField
                    {...t('variantConfiguratorDetails:fields.packages.packageTypePrice', { returnObjects: true })}
                    company={variantConfigurator.company}
                    disabled={disabled}
                    name={`${name}packageType.packageTypeWithPriceInput.price`}
                    required
                />
            </Col>
            <Col lg={8} xs={24}>
                <FormFields.SwitchField
                    {...t('variantConfiguratorDetails:fields.packages.packageTypeFinancing', { returnObjects: true })}
                    {...yesNoSwitch}
                    disabled={disabled}
                    name={`${name}packageType.packageTypeWithPriceInput.financing`}
                />
            </Col>
        </>
    );
};

export default PackagePriceTypeFieldGroup;
